import React, {useContext} from 'react';
import {Outlet} from "react-router-dom";
import { AppContext } from './AppContext';

class Page extends React.Component {
    constructor(props) {
        super(props);
        //this.setPageElement();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //this.setPageElement();
    }

    setPageElement() {
        /*console.error('DEBUG <Page /> this.props?.context?.is_initialized=', JSON.stringify(this.props?.context?.is_initialized)); // DEBUG
        if (!this.props?.context?.is_initialized) {
            this.pageElement = (
                <>
                    <Loading />
                    Latailee..
                </>
            );
            return;
        }*/
        this.pageElement = (
            <Outlet/>
        );
    }

    render() {
        return (
            <Outlet/>
        );
    }
}

const PagewithContext = (props) => {
    const context = useContext(AppContext);
    return (<Page {...props} context={context} location={location} />);
};

export default PagewithContext;
